module.exports = __webpack_public_path__ + "static/media/about-advantage.f85176ec.svg";